module.exports = __webpack_public_path__ + "media/images/form-status-needs-merch-1b1b7485.gif";